import { render, staticRenderFns } from "./SpamhausDBL.vue?vue&type=template&id=1c845b26&"
import script from "./SpamhausDBL.vue?vue&type=script&lang=js&"
export * from "./SpamhausDBL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports